import dayjs from 'dayjs';
import i18n from '../../i18n';

/**
 * Ce que la liste des registres journaliers doit montrer, et dans quel ordre.
 *
 * POURQUOI CETTE LISTE EXISTE. L'écran ne chargeait que `du-jour?date=aujourd'hui`,
 * sans sélecteur ni liste : les registres des jours passés étaient inatteignables,
 * donc impossibles à clôturer et à viser. Douze attendaient, tous au statut Ouvert,
 * dont certains de juillet. Le serveur servait déjà `GET /v1/registres` - personne
 * ne l'appelait.
 *
 * POURQUOI L'INSTANT EST UN PARAMETRE. « En retard » se compte contre aujourd'hui.
 * Figé dans la fonction, le calcul ne serait vérifiable qu'en attendant le
 * lendemain.
 */

/** Statuts, du plus ouvert au plus clos. */
export const STATUTS_REGISTRE = ['OUVERT', 'CLOS', 'VISE'];

/**
 * `dateJour` vient du serveur. On normalise avant de comparer plutôt que de parier
 * sur sa forme exacte : une comparaison de chaînes sur deux formats différents
 * échoue en silence, et c'est le genre de défaut qui ne se voit qu'au changement de
 * mois.
 */
export const jourISO = (v) => (v ? dayjs(v).format('YYYY-MM-DD') : '');

/**
 * Les registres qui attendent une action, c'est-à-dire le RETARD.
 *
 * <p>Le registre du jour est ouvert : c'est son état normal, pas un retard. Le
 * compter aurait affiché une alerte permanente que personne ne peut faire
 * disparaître avant le soir - et une alerte toujours allumée cesse d'être lue.
 */
export function registresATraiter(registres, maintenant = new Date()) {
  const aujourdhui = dayjs(maintenant).format('YYYY-MM-DD');
  return (registres || []).filter(
    (r) => r && r.statut !== 'VISE' && jourISO(r.dateJour) < aujourdhui,
  );
}

/**
 * La liste filtrée et triée, du plus récent au plus ancien.
 *
 * <p>Le tri chronologique brut aurait mis en tête le registre de juillet ; ce qui
 * attend une action est presque toujours récent. Un `filtreStatut` vide ne filtre
 * rien - c'est le choix « Tous ».
 */
export function registresAffiches(registres, filtreStatut = '') {
  return (registres || [])
    .filter((r) => r && (!filtreStatut || r.statut === filtreStatut))
    .slice()
    .sort((a, b) => jourISO(b.dateJour).localeCompare(jourISO(a.dateJour)));
}

/**
 * L'action attendue sur un registre, nommée sur sa ligne.
 *
 * <p>Un simple « Ouvrir » aurait laissé chercher, une fois le registre affiché, ce
 * qu'il y a à y faire. Un statut inconnu mène à « Consulter » : le défaut n'ouvre
 * aucune action d'écriture.
 */
export function actionDuRegistre(statut) {
  if (statut === 'OUVERT') return i18n.t('courriers:registre.liste.actions.cloturer');
  if (statut === 'CLOS') return i18n.t('courriers:registre.liste.actions.viser');
  return i18n.t('courriers:registre.liste.actions.consulter');
}
